import * as React from 'react'

const SvgLogoProjectiva = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="112"
    height="139"
    fill="none"
    viewBox="0 0 112 139"
  >
    <g clipPath="url(#clip0_117_648)">
      <g filter="url(#filter0_d_117_648)">
        <path
          fill="#C090F2"
          d="M68.638 10.493c1.883 0 3.408 1.507 3.408 3.37v16.87c0 1.863-1.528 3.37-3.409 3.37H53.962c-1.846.007-3.346 1.453-3.422 3.261h-.007v16.914c0 1.863-1.528 3.37-3.408 3.37H32.461c-1.873 0-3.394 1.48-3.439 3.327h-.003v40.555c0 1.863 1.528 3.37 3.408 3.37h14.697c1.884 0 3.408 1.508 3.408 3.371v16.869c0 1.863-1.528 3.371-3.408 3.371h-14.67c-1.883 0-3.408-1.508-3.408-3.371v-17.026c0-1.863-1.527-3.371-3.408-3.371H11.54c-2.212 0-4.006-1.774-4.006-3.962V60.958c0-1.864 1.528-3.37 3.408-3.37h14.676c1.846-.008 3.346-1.454 3.422-3.262h.007V37.412c0-1.863 1.528-3.37 3.409-3.37h14.662c1.874 0 3.394-1.484 3.44-3.327h.003V13.863c0-1.863 1.528-3.37 3.408-3.37zm0-1.62h-14.67c-2.783 0-5.047 2.238-5.047 4.99v16.812c-.024.946-.812 1.722-1.766 1.743H32.451c-2.782 0-5.047 2.239-5.047 4.99v16.723l-.006.127a1.79 1.79 0 0 1-1.79 1.709h-14.67c-2.78-.004-5.043 2.235-5.043 4.987v39.824c0 3.076 2.533 5.582 5.644 5.582h14.096c.978 0 1.77.786 1.77 1.75v17.027c0 2.752 2.264 4.991 5.046 4.991h14.67c2.782 0 5.046-2.239 5.046-4.991v-16.87c0-2.751-2.264-4.99-5.046-4.99H32.423c-.978 0-1.77-.787-1.77-1.751V61.009c.025-.95.816-1.726 1.774-1.743h.038l1.645.006v-.006h13.014c2.782 0 5.047-2.24 5.047-4.991V37.552l.007-.126a1.79 1.79 0 0 1 1.79-1.71h14.67c2.782 0 5.046-2.239 5.046-4.99V13.863c0-2.752-2.264-4.99-5.046-4.99"
        ></path>
        <path
          stroke="#C090F2"
          strokeWidth="0.5"
          d="M68.638 10.493c1.883 0 3.408 1.507 3.408 3.37v16.87c0 1.863-1.528 3.37-3.409 3.37H53.962c-1.846.007-3.346 1.453-3.422 3.261h-.007v16.914c0 1.863-1.528 3.37-3.408 3.37H32.461c-1.873 0-3.394 1.48-3.439 3.327h-.003v40.555c0 1.863 1.528 3.37 3.408 3.37h14.697c1.884 0 3.408 1.508 3.408 3.371v16.869c0 1.863-1.528 3.371-3.408 3.371h-14.67c-1.883 0-3.408-1.508-3.408-3.371v-17.026c0-1.863-1.527-3.371-3.408-3.371H11.54c-2.212 0-4.006-1.774-4.006-3.962V60.958c0-1.864 1.528-3.37 3.408-3.37h14.676c1.846-.008 3.346-1.454 3.422-3.262h.007V37.412c0-1.863 1.528-3.37 3.409-3.37h14.662c1.874 0 3.394-1.484 3.44-3.327h.003V13.863c0-1.863 1.528-3.37 3.408-3.37zm0-1.62h-14.67c-2.783 0-5.047 2.238-5.047 4.99v16.812c-.024.946-.812 1.722-1.766 1.743H32.451c-2.782 0-5.047 2.239-5.047 4.99v16.723l-.006.127a1.79 1.79 0 0 1-1.79 1.709h-14.67c-2.78-.004-5.043 2.235-5.043 4.987v39.824c0 3.076 2.533 5.582 5.644 5.582h14.096c.978 0 1.77.786 1.77 1.75v17.027c0 2.752 2.264 4.991 5.046 4.991h14.67c2.782 0 5.046-2.239 5.046-4.991v-16.87c0-2.751-2.264-4.99-5.046-4.99H32.423c-.978 0-1.77-.787-1.77-1.751V61.009c.025-.95.816-1.726 1.774-1.743h.038l1.645.006v-.006h13.014c2.782 0 5.047-2.24 5.047-4.991V37.552l.007-.126a1.79 1.79 0 0 1 1.79-1.71h14.67c2.782 0 5.046-2.239 5.046-4.99V13.863c0-2.752-2.264-4.99-5.046-4.99Z"
        ></path>
      </g>
      <g filter="url(#filter1_d_117_648)">
        <path
          fill="#C090F2"
          d="M95.079 109.426H78.816c-2.83 0-5.132-2.097-5.132-4.673V87.481c0-2.576 2.302-4.672 5.132-4.672h16.263c2.83 0 5.131 2.096 5.131 4.672v17.272c0 2.576-2.302 4.673-5.131 4.673M78.816 84.524c-1.79 0-3.248 1.328-3.248 2.957v17.272c0 1.629 1.458 2.957 3.248 2.957h16.263c1.79 0 3.247-1.328 3.247-2.957V87.481c0-1.63-1.458-2.957-3.247-2.957z"
        ></path>
        <path
          stroke="#C090F2"
          strokeWidth="0.5"
          d="M95.079 109.426H78.816c-2.83 0-5.132-2.097-5.132-4.673V87.481c0-2.576 2.302-4.672 5.132-4.672h16.263c2.83 0 5.131 2.096 5.131 4.672v17.272c0 2.576-2.302 4.673-5.131 4.673ZM78.816 84.524c-1.79 0-3.248 1.328-3.248 2.957v17.272c0 1.629 1.458 2.957 3.248 2.957h16.263c1.79 0 3.247-1.328 3.247-2.957V87.481c0-1.63-1.458-2.957-3.247-2.957z"
        ></path>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_117_648"
        width="87.49"
        height="140.955"
        x="-3.955"
        y="-0.978"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset></feOffset>
        <feGaussianBlur stdDeviation="4.8"></feGaussianBlur>
        <feComposite in2="hardAlpha" operator="out"></feComposite>
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"></feColorMatrix>
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_117_648"
        ></feBlend>
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_117_648"
          result="shape"
        ></feBlend>
      </filter>
      <filter
        id="filter1_d_117_648"
        width="46.226"
        height="46.317"
        x="63.834"
        y="72.959"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset></feOffset>
        <feGaussianBlur stdDeviation="4.8"></feGaussianBlur>
        <feComposite in2="hardAlpha" operator="out"></feComposite>
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"></feColorMatrix>
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_117_648"
        ></feBlend>
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_117_648"
          result="shape"
        ></feBlend>
      </filter>
      <clipPath id="clip0_117_648">
        <path fill="#fff" d="M0 0h112v139H0z"></path>
      </clipPath>
    </defs>
  </svg>
)

export default SvgLogoProjectiva
